import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import draggable from "vuedraggable";
import store from "@/core/services/store";
import mixins from "./mixins";
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import TerminalTitleRibbon from "@/core/plugins/TitleRibbon/install";
import CustomPopup from "@/core/plugins/TitleRibbon/plugins/popup/customPopup";
import CustomTabs from "@/core/plugins/TitleRibbon/plugins/customTabs/index.vue";
import VueTable from "@/core/plugins/TitleRibbon/plugins/vueTable/index.vue";
import "@fortawesome/fontawesome-free/css/all.css";
import "material-design-icons-iconfont/dist/material-design-icons.css";

import {
  destroyToken,
  getToken,
  saveToken,
} from "@/core/plugins/TitleRibbon/assets/js/jwt.service";
import axiosMeth from "./axiosMeth";
import "./filters";
import { ir } from "./check_domain_ir";

// Global 3rd party plugins
import "popper.js";
import "tooltip.js";
import PerfectScrollbar from "perfect-scrollbar";
import ClipboardJS from "clipboard";
// Vue 3rd party plugins
import i18n from "@/core/plugins/vue-i18n";
import vuetify from "@/core/plugins/vuetify";
import "@/core/plugins/portal-vue";
import "@/core/plugins/bootstrap-vue";
import "@/core/plugins/perfect-scrollbar";
import "@/core/plugins/highlight-js";
import "@/core/plugins/inline-svg";
import "@/core/plugins/apexcharts";
import "@/core/plugins/treeselect";
import "@/core/plugins/metronic";
import "@mdi/font/css/materialdesignicons.css";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import DataTable from "laravel-vue-datatable";
import ResponseMessageFunctions from "@/Utilities/ResponseMessageFunctions";
import $ from "jquery";
import { can } from "@/core/plugins/acl";
//Global Plugins
import GlobalComponents from "./globalComponents";
//MAP MATERIAL
import { LGeoJson, LMap, LMarker, LTileLayer } from "vue2-leaflet";
import "leaflet/dist/leaflet.css";
import svgIcon from "@/view/SvgIcon";
import { Icon } from "leaflet";
import axiosApi from "axios";
// import modal from '@/core/plugins/EasyModal/index'
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import mobileTable from "../src/core/plugins/mobileTable/src/install";
import "@/assets/css/styleHelpInfo.css";
import HelpInfo from "./view/pages/helpAcordion/HelpInfo.vue";
import HelpInfoWrapper from "./view/pages/helpAcordion/HelpInfoWrapper.vue";
import VueTelInput from "vue-tel-input";
import "vue-tel-input/dist/vue-tel-input.css";

Vue.use(VueTelInput);

export const rbAxios = axiosApi.create({
  baseURL: Vue.prototype.$robotApi,
  timeout: 15000,
  headers: {
    Authorization: localStorage.getItem("id_token"),
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
  },
});
let id_token = localStorage.getItem("id_token");
const QrAxios = axiosApi.create({
  baseURL: Vue.prototype.$qrApi,
  timeout: 15000,
  headers: {
    Authorization: !!id_token ? "Bearer " + id_token : undefined,
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
  },
});

Vue.use(ResponseMessageFunctions);
Vue.use(mobileTable);

window.$ = $;

Vue.config.productionTip = false;

let timer = null;
export const debounce = function (fn, delay) {
  clearTimeout(timer);
  timer = setTimeout(fn, delay);
};

window.axios = axiosMeth.axios;

window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
// window.axios.interceptors.response.use(response => Promise.resolve(response),    error =>
// {        if (error.response.status == 401) {            localStorage.removeItem("id_token")
// router.push({name: "login"})        }    });
window.PerfectScrollbar = PerfectScrollbar;
window.ClipboardJS = ClipboardJS;
Vue.prototype.$aiApi = ir("https://ai-api.terminalads.com/api");
Vue.prototype.$transportUrl = ir("https://core-transport.terminalads.com");
Vue.prototype.$billboardUrl = ir("https://core-billboard.terminalads.com");
Vue.prototype.$showUrl = ir("https://core-show.terminalads.com");
Vue.prototype.$digiUrl = ir("https://core-digi.terminalads.com");
Vue.prototype.$mediaUrl = ir("https://core-media.terminalads.com");
Vue.prototype.$meliUrl = ir("https://core-meli.terminalads.com");
Vue.prototype.$robotUrl = ir("https://core-robot.terminalads.com");
Vue.prototype.$infoUrl = ir("https://core-info.terminalads.com");

Vue.prototype.$crawler = ir("https://crawler.terminalads.com");
Vue.prototype.$sarveLand = ir(process.env.VUE_APP_CoreLandUrl);
Vue.prototype.$sarveLandFront = ir("https://core.terminalads.com/#/login");
Vue.prototype.$requireLogin = ir(process.env.VUE_APP_isLoginRequired);
Vue.prototype.$robatLandback = ir(process.env.VUE_APP_RobatLandBack);
Vue.prototype.$infoland = ir(process.env.VUE_APP_Infoland);
Vue.prototype.$wallet = ir(process.env.VUE_APP_WALLET_URL);
Vue.prototype.$walletApi = ir("https://wallet.terminalads.com/api/");
Vue.prototype.$coreApi = ir("https://core.terminalads.com");
Vue.prototype.$qrApi = ir("https://core-qr.terminalads.com/api"); //https://qr-api.terminalads.com/api
Vue.prototype.$mediaApi = ir("https://media.terminalads.com");
Vue.prototype.$linkApi = ir("https://link.terminalads.com");
Vue.prototype.$robotApi = ir("https://robot-api.terminalads.com/api");
Vue.prototype.$payamakApi = ir("https://sms-api.terminalads.com/api");
Vue.prototype.$payamakApi2 = ir("https://sms-api.terminalads.com/api/");
Vue.prototype.$coreLogin = ir("https://core.terminalads.com/#/login");
Vue.prototype.$fileApi = ir("https://file-api.terminalads.com/api");
Vue.prototype.$fileApi2 = ir("https://file-api.terminalads.com/api/");
Vue.prototype.$corepayamakApi = ir("https://core-sms.terminalads.com");
Vue.prototype.$terminalads = ir("https://terminalads.com");
Vue.prototype.$coreqrOrigin = ir("core-qr.terminalads.com");
Vue.prototype.$robotCoreApi = ir("https://core-robot.terminalads.com");
Vue.prototype.$coreqrApi = ir("https://core-qr.terminalads.com");
Vue.prototype.$digiApi = ir("https://core-digi.terminalads.com");
Vue.prototype.$panel = ir("https://panel.terminalads.com");
Vue.prototype.$terminal = ir(".terminalads.com");
Vue.prototype.$coreApi3 = ir("https://api.terminalads.com");
Vue.prototype.$coreApi2 = ir("https://api.terminalads.com/api");
Vue.prototype.$mediaApi = ir("https://media.terminalads.com");
Vue.prototype.$linkApi = ir("https://link.terminalads.com");
Vue.prototype.$payamakApi = ir("https://sms-api.terminalads.com/api");
Vue.prototype.$payamakApi2 = ir("https://sms-api.terminalads.com/api/");
Vue.prototype.$coreLogin = ir("https://core.terminalads.com/#/login");
Vue.prototype.$fileApi = ir("https://file-api.terminalads.com/api");
Vue.prototype.$fileApi2 = ir("https://file-api.terminalads.com/api/");
Vue.prototype.$terminalads = ir("https://terminalads.com");

Vue.prototype.$assets = {
  logo: ir(
    "https://api.terminalads.com/storage/s5wXoRhzyw9PkGXA8qnIL2yvA3TPiXhwsFrwjmeX.png",
  ),
};
Vue.prototype.$services = {
  1: ir("https://core.terminalads.com"),
  2: ir("https://core-sms.terminalads.com"),
  3: ir("https://core-qr.terminalads.com"),
  4: ir("https://core-robot.terminalads.com"),
  5: ir("https://core-billboard.terminalads.com"),
  10: ir("https://core-info.terminalads.com"),
  11: ir("https://core-file.terminalads.com"),
  13: ir("https://core-digi.terminalads.com"),
  14: ir("https://core-graphic.terminalads.com"),
};

Vue.use(VueSweetalert2);
Vue.use(DataTable);
Vue.use(GlobalComponents);

// Vue.use(modalinstall)

// import {install as toastinstall} from '@/Utilities/ToastFunctions'
// Vue.use(toastinstall)

Vue.component("l-map", LMap);
Vue.component("l-tile-layer", LTileLayer);
Vue.component("l-marker", LMarker);
Vue.component("l-marker", LGeoJson);
Vue.component("customPopup", CustomPopup);
Vue.component("customTabs", CustomTabs);
Vue.component("vueTable", VueTable);
Vue.component("t-image", svgIcon);
Vue.component("draggable", draggable);
Vue.component("HelpInfo", HelpInfo);
Vue.component("HelpInfoWrapper", HelpInfoWrapper);

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

export const Bus = new Vue({
  methods: {
    setProp(name, value) {
      this[name] = value;
    },
    getProp(name) {
      return this[name];
    },
  },
});

Vue.component("date-picker", VuePersianDatetimePicker);

Vue.use(Toast, {
  position: "top-center",
  timeout: 2000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: true,
  hideProgressBar: false,
  closeButton: "button",
  icon: true,
  rtl: true,
  maxToasts: 1,
  newestOnTop: true,
  color: "black",
});

Vue.use(mixins);

let dashboardConfig = {
  announcement: {
    img:
      Vue.prototype.$robotCoreApi +
      "/advertisement-billboard-6097659-5013090.png", // url
    text: "پیامک های ارسال شده", // any
    url: router.resolve({ name: "divar.report" }).href, // page to go
  },
  numbers: {
    img:
      Vue.prototype.$robotCoreApi +
      "/advertisement-billboard-6097659-5013090.png", // require from local assets
    text: "پیامک های دریافت شده",
    url: router.resolve({ name: "divar.report" }).href,
  },
  counter: () =>
    new Promise((resolve) => {
      window.Vue.requestApiGet("admin/message/payamaks/count").then(
        ({ data }) => {
          resolve({
            announcement: data.data?.payamaks,
            numbers: data.data?.rcvMessages,
          });
        },
      );
    }),
};

Vue.use(TerminalTitleRibbon, {
  store,
  axios,
  config: () => ({
    dashboardConfig,
    static_top_menu: [],
    header_logo: store.getters.headerLogo,
  }),
  headers: {
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
  },
  permissions: () => window.Vue.$ability.j[0].action,
  core_url: Vue.prototype.$sarveLand,
  front_url: Vue.prototype.$coreApi,
  sid: 2,
});

// Vue.use(modal)

window.Vue = new Vue({
  data() {
    return {
      Loaded: 0,
      LoadCount: 1,
    };
  },
  methods: {
    async fetch() {
      if (!getToken()) {
        const { origin, hash } = window.location;

        destroyToken(origin, hash.substring(1));
      } else {
          try {
          await this.checkTokenAsync(getToken());
          // load abilities
          let response = await this.requestApiGetCore("abilitiesType");
          this.$ability.update([{ subject: "all", action: response.data }]);
          this.addLoaded();
        } catch (e) {
          console.log("error: ", e);
        }
      }
    },
    setToken() {
      let url = window.location.href;
      const start = url.indexOf("?");
      const end = url.indexOf("#");
      url = url.substring(start, end);
      let token = url.split("token=")[1];
      // let dataToken = url.split('=')[1];
      if (token) {
        saveToken(token);
        // this.$store.commit('isAuthenticated', true);
        // let fullUrl = document.URL;
        return window.history.pushState(
          "dashboard",
          "Title",
          "/" + window.location.hash,
        );
      }
    },
    addLoaded() {
      this.Loaded++;
      if (this.Loaded >= this.LoadCount) {
        this.$store.dispatch("global/isLoaded", true);
      }
    },
  },
  async beforeMount() {
    this.setToken();

    router.beforeResolve(async (to, from, next) => {
      window.Vue.$store.getters["global/isLoaded"] || (await this.fetch());
      if (to.meta.permission) {
        if (Array.isArray(to.meta.permission)) {
          const hasPermission = to.meta.permission.some((p) => can(p));
          if (!hasPermission) {
            next({ name: "dashboard" });
          }
        } else {
          if (!can(to.meta.permission)) {
            next({ name: "dashboard" });
          }
        }
      }
      next();
    });
  },
  router,
  store,
  i18n,
  vuetify,
  render: (h) => h(App),
});

window.Vue.$mount("#app");

export { QrAxios };
